// extracted by mini-css-extract-plugin
export var social = "Social-module--social--2iS17";
export var socialPrimary = "Social-module--social--primary--2j1Xm";